import React, { useState, useCallback } from "react";
import ClientArticleForm from "Components/Article/ClientArticleForm";
import { useNavigate, useRouteLoaderData, Link } from "react-router-dom";
import Paper from "Components/UI/Paper";
import DeleteDialog from "Components/UI/Dialogs/DeleteDialog";
import useDeleteDialog from "Components/UI/Dialogs/useDeleteDialog";
import usePost from "Hooks/usePost";
import { updateClientArticle } from "API/swesum";

//MUI
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import Box from "@mui/material/Box";
import ClientArticleFormSystem from "Components/Article/ClientArticleFormSystem";
import { usePopupNotificationContext } from "Context/NotificationPopup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function ClientArticleCard({ clientArticle, payRuleOptions }) {
  const [formData, setFormData] = useState({
    Id: clientArticle.Id,
    Name: clientArticle.Name,
    DebitAccountChartId: clientArticle.DebitAccountChartId,
    CreditAccountChartId: clientArticle.CreditAccountChartId,
    VAT: clientArticle.VAT,
    Payrule: clientArticle.Payrule,
    Paytype: clientArticle.Paytype,
    ParseMessage: clientArticle.ParseMessage,
    ParseStatus: clientArticle.ParseStatus,
    SystemStatus: clientArticle.SystemStatus,
    CreateTime: clientArticle.CreateTime,
  });
  const deleteDialog = useDeleteDialog(false);
  const { openSuccess, openError } = usePopupNotificationContext();
  const navigate = useNavigate();
  const updateClientAccReq = usePost({
    mtnFunc: (body) => {
      return updateClientArticle(clientArticle.Id, body);
    },
    onSuccess: (data) => {
      openSuccess(`Sparat! ${data.ParseMessage && data.ParseMessage} `, 3000);
    },
    onError: () => {
      openError("Ett fel har uppstått", 3000);
    },
  });

  const deleteClientAccReq = usePost({
    mtnFunc: (inputs) => {
      return deleteClientAccReq(clientArticle.Id);
    },
    onSuccess: (data) => {
      navigate("/clientsarticles");
    },
    onError: () => {
      deleteDialog.close();
      openError("Ett fel har uppstått.", 3000);
    },
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography
              sx={{ marginBottom: "1.0rem" }}
              variant="h5"
              align="left"
            >
              Klientartikelkort
            </Typography>

            <TabPanel value={tabIndex} index={0}>
              <ClientArticleForm
                formData={formData}
                handleInputChange={handleInputChange}
                payRuleOptions={payRuleOptions}
              />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
              <ClientArticleFormSystem
                formData={formData}
                handleInputChange={handleInputChange}
              />
            </TabPanel>

            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button onClick={() => navigate(-1)}>Stäng</Button>

              <Button
                onClick={() => updateClientAccReq.post(formData)}
                variant="contained"
                sx={{ ml: 3 }}
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <DeleteDialog
        title={"Ta bort klientartikel"}
        isOpen={deleteDialog.isOpen}
        handleClose={deleteDialog.close}
        handleDelete={() => deleteClientAccReq.post()}
      >
        Klientartikeln kommer att tas bort.
      </DeleteDialog>
    </>
  );
}
